import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "titlePages" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { computed, onMounted, ref, Ref, ComputedRef } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import CardTopology from '@/components/SmartLink/topology/CardTopology.vue';
import CompareCharts from '@/components/SmartLink/charts/CompareCharts.vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { STRING_GENERAL } from '@/constants/labels';
import { LABELS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';

/********************************
 ********** INTERFACES **********
 *******************************/
import { PREDICT_GRAPH } from '@/interfaces/SmartLink/IA';
import { HEADER } from '@/interfaces/SmartLink/Tables'

/********************************
 *********** SERVICES ***********
 *******************************/
import { getAllPredictionRXTXData, getPredictionRXTXByIP } from '@/services/Smartlink/Predict';

/**
 * HEADER de la tabla
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'PredictView',
  setup(__props) {

const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ********** CONSTANTES **********
 *******************************/
const finalHeardes:ComputedRef<HEADER[]> = computed(() => [
    { text:  t('labels.date'),      value: "fecha",     sortable: false},
    { text:  t('labels.ip'),        value: "ip",        sortable: false},
    { text:  t('labels.cause'),     value: "causa",     sortable: false},
    { text:  t('labels.value'),     value: "detalle",   sortable: false},
])

/**
 * Mostrar el Dialogo
 */
const dialog = ref(false);

/**
 * Si es false, el apartado de error, en vez de mostrar información o un espacio vacío. 
 * Generalmente es cuando desde la API no trae valores.
 * Si es true, muestra todal a información obtenida de la API
 */
const showPredict = ref(false);

/**
 * Son los parámetros que se envían a la API
 */
const params = ref({link : ''});

/**
 * Nombre del equipo seleccionado para mostrar su dialog
 */
 const titleDialog = ref('');

/**
 * Cuando le das click a algún item, captura su ip y su nombre
 * lo manda a la función "getPredict" mandando su parametros
 * all => para la tabla
 * pred/real => para el gráfico
 * muestra el dialog de los gráficos
 */
function pressItem(ip:string, name:string) {
    dialog.value        = true;
    titleDialog.value   = name;
    params.value.link   = ip;
    getPredict(STRING_GENERAL.predictall);
    getPredict(STRING_GENERAL.predictreal);
    getPredict(STRING_GENERAL.predictpred);
}


/**
 * Valor principal de los predicts
 */
const principalData = ref();

/**
 * Captura todos los items tienen predicciones
 * traidos de la API: "getAllPredictRXLVLData"
 */
async function getAllPredRXData() {

    const allData = await getAllPredictionRXTXData()

    showPredict.value = allData.showGraphs;

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        principalData.value = allData.data
    }
     
}


/**
 * Valor Real del gráfico
 */
 const valorOne:Ref<number[][]>      = ref([]);

/**
 * Valor Predict del Gráfico
 */
const valorTwo:Ref<number[][]>      = ref([]);

/**
 * Valor de la tabla
 */
const items:Ref<PREDICT_GRAPH[]>    = ref([]);

/**
 * Fecha del predict
 */
 const titleDate                     = ref('');

/**
 * Valor del predict
 */
const titleValue                    = ref('');

/**
 * Hace el pedido a la API según el tipo
 * @param type Tipo de Predicción de la API 
 */
async function getPredict(type:string) {

    const allData = await getPredictionRXTXByIP(type, params.value);

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        if(type === STRING_GENERAL.predictall)     items.value    = allData.data;
        if(type === STRING_GENERAL.predictreal)    {
            valorOne.value = allData.data;
        }

        if(type === STRING_GENERAL.predictpred){
            valorTwo.value = allData.data;

            const fecha         =  new Date(allData.data.slice(-1)[0][0]);
            titleDate.value     = fecha.toLocaleString("es-PE");
            titleValue.value    = (allData.data.slice(-1)[0][1]).toString();
        }    
    } 
}

onMounted(()=>{
    getAllPredRXData();
})


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "defaultCard",
    color: "bgtopology"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('analyticsPage.titlerx')), 1),
      (showPredict.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "ma-0"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(principalData.value, (item, i) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  class: "my-3",
                  cols: "12",
                  sm: "4",
                  md: "3",
                  lg: "2",
                  xl: "2",
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createVNode(CardTopology, {
                      status: item.status,
                      ip: item.ip,
                      title: item.name,
                      description: item.tipo,
                      onClick: ($event: any) => (pressItem(item.ip,item.name))
                    }, null, 8, ["status", "ip", "title", "description", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_component_v_dialog, {
                modelValue: dialog.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
                width: "85%"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "card_dialog",
                    color: "background"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "ma-0",
                        justify: "space-between",
                        style: {"align-items":"self-end !important"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "10" }, {
                            default: _withCtx(() => [
                              (_unref(xs))
                                ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_unref(t)('title.graphTitle')) + " " + _toDisplayString(titleDialog.value), 1))
                                : (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(t)('title.graphTitle')) + " " + _toDisplayString(titleDialog.value), 1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                icon: "mdi-close",
                                variant: "plain",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
                              })
                            ]),
                            _: 1
                          }),
                          (valorTwo.value.length !== 0)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                style: _normalizeStyle(_unref(xs) ? 'text-align:start' :'text-align:end'),
                                class: "pr-16"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(_unref(xs) ? 'datePredict' : '')
                                  }, _toDisplayString(_unref(t)('analyticsPage.titleDial1')) + " [ " + _toDisplayString(titleDate.value) + " ] - " + _toDisplayString(_unref(t)('analyticsPage.titleDial2')) + " " + _toDisplayString(titleValue.value), 3)
                                ]),
                                _: 1
                              }, 8, ["style"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_sheet, {
                        class: "defaultCard text-center",
                        color: "bgtopology"
                      }, {
                        default: _withCtx(() => [
                          (valorOne.value.length > 0  && valorTwo.value.length > 0)
                            ? (_openBlock(), _createBlock(CompareCharts, {
                                key: 0,
                                "name-primary": "Real",
                                "color-first": _unref(COLOR).compare13,
                                "color-second": _unref(COLOR).compare14,
                                "name-secundary": _unref(t)('labels.predict'),
                                title: _unref(t)('analyticsPage.predvsreal1'),
                                subtitle: _unref(t)('analyticsPage.predvsreal2'),
                                "first-array": valorOne.value,
                                "second-array": valorTwo.value,
                                typeChart: _unref(STRING_GENERAL).predict
                              }, null, 8, ["color-first", "color-second", "name-secundary", "title", "subtitle", "first-array", "second-array", "typeChart"]))
                            : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_sheet, {
                        class: "defaultCard",
                        color: "bgtopology"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EasyDataTable, {
                            "table-class-name": "customize-table",
                            headers: finalHeardes.value,
                            items: items.value,
                            "show-index": "",
                            "hide-footer": ""
                          }, null, 8, ["headers", "items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "ma-0 px-4 py-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h3", null, _toDisplayString(_unref(t)('noInformation')), 1)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})